module.exports = __webpack_public_path__ + "img/1.878dc183.png";